import AlertModal from 'components/common/AlertModal';
import useGlobalModal from 'components/common/GlobalModal/useGlobalModal';
import ImageUploadModal from 'components/common/ImageUploadModal';
import MultiSelectDropdown from 'components/common/MultiSelectDropdown';
import ja from 'date-fns/locale/ja';
import { MENU_DISPLAY_TIMING_SUB } from 'features/MenuList/constants';
import { Overlay } from 'features/OverlayFunction/models/overlay';
import { Menu, MenuDetail } from 'features/SubTitleMenu/models/SubTitleMenu';
import { Formik } from 'formik';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { Button, Col, Form, Row, Table } from 'react-bootstrap';
import DatePicker, { registerLocale } from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { getCurrency } from 'utils/common';
import { IMAGE_SIZES } from 'utils/constants';
import * as yup from 'yup';
import '../Detail.scss';
import service from '../services';
registerLocale('ja', ja);

interface PropsData {
  menuDetail: MenuDetail;
  id: string;
  handleCloseModalEdit: (status: boolean) => void;
  dataTable?: MenuDetail[];
  setDataTable?: (menus: MenuDetail[]) => void;
}

function SubTitleMenuFormDetail({ menuDetail, id, handleCloseModalEdit, dataTable, setDataTable }: PropsData) {
  const menu = menuDetail.menu;
  const { t } = useTranslation();
  const { showGlobalModal } = useGlobalModal();
  const [previewBg, setPreviewBg] = useState<string>('');
  const schema = yup.object().shape({});
  const [startDate, setStartDate] = useState<Date>(new Date(menuDetail.start_date));
  const [endDate, setEndDate] = useState<Date>(new Date(menuDetail.end_date));

  useEffect(() => {
    if (menu && typeof menu.img == 'string' && menu.img) {
      setPreviewBg(menu.img);
    }
  }, [menu]);

  const initialValues: Menu = {
    id: menuDetail.menu?.id || 0,
    img: menuDetail.menu?.img || '',
    display_name: menuDetail.name || '',
    display_name_ja: menuDetail.menu?.display_name_ja || '',
    display_name_en: menuDetail.menu?.display_name_en || '',
    display_name_vi: menuDetail.menu?.display_name_vi || '',
    display_name_ko: menuDetail.menu?.display_name_ko || '',
    display_name_zh_hant: menuDetail.menu?.display_name_zh_hant || '',
    display_name_zh_hans: menuDetail.menu?.display_name_zh_hans || '',
    note: menuDetail.menu?.note || '',
    delete_flg: false,
    type: 3,
    coupon_classification: 3,
    display_timing: 1,
    explanation: menuDetail?.menu?.explanation || '',
    explanation_en: menuDetail?.menu?.explanation_en || '',
    explanation_ja: menuDetail?.menu?.explanation_ja || '',
    explanation_vi: menuDetail?.menu?.explanation_vi || '',
    explanation_ko: menuDetail?.menu?.explanation_ko || '',
    explanation_zh_hant: menuDetail?.menu?.explanation_zh_hant || '',
    explanation_zh_hans: menuDetail?.menu?.explanation_zh_hans || '',
    note1: '',
    note1_en: '',
    note1_ja: '',
    note1_vi: '',
    note1_ko: '',
    note1_zh_hant: '',
    note1_zh_hans: '',
    note2: '',
    note2_en: '',
    note2_ja: '',
    note2_vi: '',
    note2_ko: '',
    note2_zh_hant: '',
    note2_zh_hans: '',
    start_date: startDate,
    end_date: endDate,
    is_sub: menuDetail.menu?.is_sub || false,
    overlay_group: menuDetail.menu?.overlay_group || 0,
    overlay_group_id: menuDetail.menu?.overlay_group_id || 0,
    sub_overlay_group: menuDetail.menu?.sub_overlay_group || 0,
    sub_overlay_group_id: menuDetail.menu?.sub_overlay_group_id || 0,
    order_quantity_limit_type: menuDetail.menu?.order_quantity_limit_type || 0,
    sub_display_timing: menuDetail.menu?.sub_display_timing || 0,
  };

  function onClose() {
    handleCloseModalEdit && handleCloseModalEdit(true);
  }

  const [overlayGroups, setOverlayGroups] = useState<Overlay[]>([]);
  useEffect(() => {
    service.getOverlayGroups().then((res) => {
      res.data && setOverlayGroups(res.data);
    });
  }, []);

  async function HandleSubmitForm(values: Menu) {
    const payload = {
      ...values,
      start_date: moment(values.start_date).format('YYYY-MM-DD'),
      end_date: moment(values.end_date).format('YYYY-MM-DD'),
    };
    await service
      .updateMenu(payload, id)
      .then((res) => {
        const tables =
          dataTable &&
          dataTable?.map((value: MenuDetail) => {
            if (value.id === res.data.id) {
              value = res.data;
              return value;
            }
            return value;
          });
        if (tables) setDataTable && setDataTable(tables);
      })
      .then(() => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              onClose={onClose}
              title={t('SubTitleMenu.Validator.success')}
              message={t('SubTitleMenu.Validator.add_success')}
            ></AlertModal>
          ));
      })
      .catch((error) => {
        showGlobalModal &&
          showGlobalModal(() => (
            <AlertModal
              title={t('SubTitleMenu.Validator.error')}
              message={JSON.stringify(error.response.data.data)}
            ></AlertModal>
          ));
      });
  }

  return (
    <Formik validationSchema={schema} onSubmit={HandleSubmitForm} initialValues={initialValues}>
      {({ handleSubmit, handleChange, values, errors, setFieldValue }) => {
        return (
          <Form className="row" noValidate onSubmit={handleSubmit}>
            <Row>
              <Col className="col-auto">
                <p style={{ backgroundColor: '#E1D5E7' }} className="p-2 text-dark">
                  {t('SubTitleMenu.Detail')} {menuDetail?.menu?.food_system_menu?.name}
                </p>
              </Col>
            </Row>
            <Row>
              <Col className="col-md-10 mb-3"></Col>
              <Col className="col-auto">
                <Button
                  className="pull-right"
                  onClick={() => {
                    handleSubmit();
                  }}
                  variant="success"
                >
                  {t('SubTitleMenu.Button.keep')}
                </Button>
              </Col>
            </Row>

            <Col sm={6} md={6} lg={6} xl={6}>
              <Row>
                <Col className="md-auto">
                  <h5>{t('SubTitleMenu.MenuSettings')}</h5>
                </Col>
                <Col className="md-auto"></Col>
              </Row>
              <Form.Group as={Row} className="mb-3">
                <Col sm={8} md={8} lg={8} xl={8}>
                  <div dangerouslySetInnerHTML={{ __html: t('SubTitleMenu.Desc') }}></div>
                </Col>
                <Col sm={4} md={4} lg={4} xl={4}></Col>
              </Form.Group>
              <Table bordered className="table-subtitle">
                <tbody>
                  <tr>
                    <td colSpan={3} className="td-color">
                      {t('SubTitleMenu.Form.display_name')}
                    </td>
                    <td>{menuDetail?.menu?.food_system_menu?.name}</td>
                  </tr>
                  <tr>
                    <td className="td-color col-md-4" style={{ width: '20%' }} rowSpan={3}>
                      {t('SubTitleMenu.Form.date')}
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color col-md-4" style={{ width: '20%' }} colSpan={2}>
                      {t('SubTitleMenu.Form.start_date')}
                    </td>
                    <td>
                      <DatePicker
                        selected={startDate}
                        onChange={(date) => {
                          setFieldValue('start_date', date);
                          setStartDate(date ? date : new Date());
                        }}
                        dateFormat="yyyy/MM/dd"
                        locale="ja"
                        selectsStart
                        startDate={startDate}
                        endDate={endDate}
                        name="start_date"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.end_date')}
                    </td>
                    <td>
                      <DatePicker
                        selected={endDate}
                        onChange={(date) => {
                          setFieldValue('end_date', date);
                          setEndDate(date ? date : new Date());
                        }}
                        dateFormat="yyyy/MM/dd"
                        locale="ja"
                        selectsEnd
                        startDate={startDate}
                        endDate={endDate}
                        minDate={startDate}
                        name="end_date"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={3}>
                      {t('SubTitleMenu.Form.image')}
                    </td>
                    <td className="genre">
                      <input
                        type="button"
                        onClick={() => {
                          showGlobalModal &&
                            showGlobalModal(() => (
                              <ImageUploadModal
                                imagepath={
                                  previewBg && previewBg.length > 0 ? process.env.REACT_APP_IMAGE_URL + previewBg : ''
                                }
                                minWidth={IMAGE_SIZES.sub_title_menu.minWidth}
                                minHeight={IMAGE_SIZES.sub_title_menu.minHeight}
                                maxWidth={IMAGE_SIZES.sub_title_menu.maxWidth}
                                maxHeight={IMAGE_SIZES.sub_title_menu.maxHeight}
                                maxFileSize={IMAGE_SIZES.sub_title_menu.maxFileSize}
                                onReflect={(filename: string, imagepath: string) => {
                                  setFieldValue('img', filename);
                                  setPreviewBg(filename);
                                }}
                              />
                            ));
                        }}
                        id="actual-img"
                        hidden
                        name="img"
                      />
                      <label htmlFor="actual-img" style={{ marginRight: 10 }}>
                        {t('SubTitleMenu.Form.image')}
                      </label>
                      {previewBg && (
                        <img
                          src={process.env.REACT_APP_IMAGE_URL + previewBg}
                          alt="img"
                          width={IMAGE_SIZES.sub_title_menu.minWidth}
                          height={IMAGE_SIZES.sub_title_menu.minHeight}
                        />
                      )}
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" rowSpan={7}>
                      {t('SubTitleMenu.Form.show_name')}
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.japanese')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.display_name_ja}
                        name="display_name_ja"
                        placeholder="セレクトランチ"
                      />
                      <Form.Control.Feedback type="invalid">{errors.display_name_ja}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.english')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.display_name_en}
                        name="display_name_en"
                        placeholder="Select lunch"
                      />
                      <Form.Control.Feedback type="invalid">{errors.display_name_en}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.simplified_chinese')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        name="display_name_zh_hans"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.display_name_zh_hans}
                        placeholder="自由组合午餐"
                      />
                      <Form.Control.Feedback type="invalid">{errors.display_name_zh_hans}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.chinese_traditional')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        name="display_name_zh_hant"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.display_name_zh_hant}
                        placeholder="自由组合午餐"
                      />
                      <Form.Control.Feedback type="invalid">{errors.display_name_zh_hant}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.korean')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        name="display_name_ko"
                        value={values.display_name_ko}
                        placeholder="셀렉트 점심"
                      />
                      <Form.Control.Feedback type="invalid">{errors.display_name_ko}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.vietnamese')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        name="display_name_vi"
                        value={values.display_name_vi}
                        placeholder="Select lunch"
                      />
                      <Form.Control.Feedback type="invalid">{errors.display_name_vi}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" rowSpan={7}>
                      {t('SubTitleMenu.Form.extend')}
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.japanese')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.explanation_ja}
                        name="explanation_ja"
                        placeholder="セレクトランチ"
                      />
                      <Form.Control.Feedback type="invalid">{errors.explanation_ja}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.english')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.explanation_en}
                        name="explanation_en"
                        placeholder="Select lunch"
                      />
                      <Form.Control.Feedback type="invalid">{errors.explanation_en}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.simplified_chinese')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        name="explanation_zh_hans"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.explanation_zh_hans}
                        placeholder="自由组合午餐"
                      />
                      <Form.Control.Feedback type="invalid">{errors.explanation_zh_hans}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.chinese_traditional')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        name="explanation_zh_hant"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        value={values.explanation_zh_hant}
                        placeholder="自由组合午餐"
                      />
                      <Form.Control.Feedback type="invalid">{errors.explanation_zh_hant}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.korean')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        name="explanation_ko"
                        value={values.explanation_ko}
                        placeholder="셀렉트 점심"
                      />
                      <Form.Control.Feedback type="invalid">{errors.explanation_ko}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={2}>
                      {t('SubTitleMenu.Form.vietnamese')}
                    </td>
                    <td>
                      <Form.Control
                        type="text"
                        onChange={(event) => {
                          handleChange(event);
                        }}
                        name="explanation_vi"
                        value={values.explanation_vi}
                        placeholder="Select lunch"
                      />
                      <Form.Control.Feedback type="invalid">{errors.explanation_vi}</Form.Control.Feedback>
                    </td>
                  </tr>
                  <tr>
                    <td className="td-color" colSpan={3}>
                      {t('SubTitleMenu.Form.remarks')}
                    </td>
                    <td>
                      <Form.Control as="textarea" onChange={handleChange} value={values.note} name="note" rows={3} />
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col sm={6} md={6} lg={6} xl={6}>
              <h5>{t('menuDetailFeature.Text.sub_menu_settings')}</h5>
              <Table className="table table-bordered text-center align-middle mb-3">
                <tbody>
                  <tr>
                    <td className="table-primary col-md-4" colSpan={2}>
                      {t('menuDetailFeature.Text.sub_menu_property')}
                    </td>
                    <td>{values?.is_sub ? '〇' : 'X'}</td>
                  </tr>
                  <tr>
                    <td className="table-primary col-md-6" colSpan={2}>
                      {t('menuDetailFeature.Text.display_timing')}
                    </td>
                    <td>
                      <div className="row justify-content-center align-items-center">
                        <div className="col-xs-5 col-sm-5">
                          <span>{t('menuDetailFeature.Text.control_condition')}</span>
                        </div>
                        <div className="col-xs-7 col-sm-7">
                          <Form.Select
                            onChange={() => {
                              handleChange({
                                target: { name: 'sub_display_timing', value: values?.sub_display_timing === 6 ? 1 : 6 },
                              });
                            }}
                            defaultValue={values?.sub_display_timing}
                          >
                            {MENU_DISPLAY_TIMING_SUB.map((condition, index) => {
                              return (
                                <option key={index} value={condition.value}>
                                  {condition.key}
                                </option>
                              );
                            })}
                          </Form.Select>
                        </div>
                      </div>

                      <div className="row align-items-center mt-3">
                        <div className="col-xs-5 col-sm-5">
                          <div
                            dangerouslySetInnerHTML={{ __html: t('menuDetailFeature.Text.display_control_group') }}
                          ></div>
                        </div>
                        <div className="col-xs-7 col-sm-7 mb-3">
                          <MultiSelectDropdown
                            defaultText={'選択無し'}
                            options={[]}
                            selectedValues={values?.sub_display_control_groups || []}
                            onChange={() => {}}
                            isDisabled={values?.sub_display_timing !== 6}
                          />
                        </div>
                        <div dangerouslySetInnerHTML={{ __html: t('menuDetailFeature.Text.note3') }}></div>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <td className="table-primary" colSpan={2}>
                      <h5>{t('menuDetailFeature.Text.overlay_group')}</h5>
                    </td>
                    <td>
                      <div className="text-center d-flex justify-content-around mt-3 mb-3">
                        <div className="col-xs-12 col-sm-8">
                          <Form.Select
                            onChange={(e) => {
                              setFieldValue('sub_overlay_group', e.target.value);
                            }}
                            value={values?.sub_overlay_group}
                          >
                            <option value="0">{t('menuDetailFeature.Text.default_overlay_group')}</option>
                          </Form.Select>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
              <div>
                <h5>{t('SubTitleMenu.RegisterInformation')}</h5>
                <Table bordered className="table-subtitle">
                  <thead>
                    <tr>
                      <th colSpan={5} style={{ textAlign: 'center', backgroundColor: '#CFC9C9' }}>
                        {t('SubTitleMenu.Form.register_information_note')}
                      </th>
                    </tr>
                    <tr>
                      <th style={{ backgroundColor: '#CFC9C9' }}>{t('SubTitleMenu.Form.pos_cd')}</th>
                      <th style={{ backgroundColor: '#CFC9C9' }}>{t('SubTitleMenu.Form.normal')}</th>
                      <th style={{ backgroundColor: '#CFC9C9' }}>{t('SubTitleMenu.Form.normal_price')}</th>
                      <th style={{ backgroundColor: '#CFC9C9' }}>{t('SubTitleMenu.Form.sub')}</th>
                      <th style={{ backgroundColor: '#CFC9C9' }}>{t('SubTitleMenu.Form.sub_price_inclusive_tax')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{menuDetail.pos_code.cd}</td>
                      <td>{menuDetail.pos_code.normal_flg ? '〇' : 'ー'}</td>
                      <td>{getCurrency(menuDetail.standard_price) ?? t('menuDetailFeature.Text.not_obtained')}</td>
                      <td>{menuDetail.pos_code.sub_flg ? '〇' : 'ー'}</td>
                      <td>{getCurrency(menuDetail.pos_code.main_price) ?? t('menuDetailFeature.Text.not_obtained')}</td>
                    </tr>
                  </tbody>
                </Table>
              </div>
            </Col>
          </Form>
        );
      }}
    </Formik>
  );
}

export default SubTitleMenuFormDetail;
